module.exports = __webpack_public_path__ + "media/images/ui__themeToggleDark-02c83a6f713768ef47ed9867c89f1246.png";